<template>
<div class="popup_wrpr app_settings_popup_wrpr active">
    <div class="app_settings_popup" :class="{right_open: showRightPanel}">
        <div class="popup_left_side">

            <a class="close_popup_btn" @click.prevent="closePopup">
                <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
            </a>

            <a class="right_toggle" :class="{active: showRightPanel}" @click.prevent="showRightPanel = !showRightPanel">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.96124 8.03874L6.37208 8.6279L2.74416 4.99999L6.37208 1.37207L6.96124 1.96124L3.92249 4.99999L6.96124 8.03874Z" fill="#E4E6F1"></path>
                </svg>
            </a>

            <div class="popup_side_content funnel-app-settings" >
                <Loading v-show="loading"/>
<!--                <h3 class="popup_title">App settings</h3>-->
                <div class="funnel_app_item margin-b-30">
                    <div class="left">
                        <div class="img_wrpr" v-if="thisApp.attributes">
	                        <img v-if="thisApp.attributes['image-url']" :src="thisApp.attributes['image-url']">
                          <img v-else :src="'data:image/png;base64,' + thisApp.attributes.image" alt="">
                        </div>
                        <div class="text_content">
                            <h3>{{thisApp.attributes.name}}
                                <div class="info_btn" @click="showRightPanel = !showRightPanel">
                                  <span>Help</span>
                                    <inline-svg :src="require('@/assets/img/info_icon.svg')"/>
                                </div>
                            </h3>
                            <p>{{thisApp.attributes.description}}</p>
                        </div>
                    </div>
	                <div class="layout-column flex-center on-button">
		                <v-switch no-label v-model="app.attributes.active" :value="app.attributes.active" />
		                <span v-if="app.attributes.active" class="active">ACTIVE</span>
		                <span v-else class="inactive" content="App is inactive!"
		                      v-tippy='{ arrow : true, showOnInit:true,distance:15,interactive:true,delay:1000,theme:"red",sticky: true,hideOnClick:false,placement:"bottom" }'>INACTIVE</span>
	                </div>
                </div>

                <template v-if="newDataConfig && (typeof config === 'array' || typeof config === 'object')">
                    <div class="brdr_box_w_checkbox" v-for="(item, index) in config" :key="index">

                        <template v-if="item.type === 'helpbox'">
                            <div class="right w100 helpbox">
                                <h3>{{ item.title }}</h3>
                                <div v-html="item.body"></div>
                                <ul>
                                    <li v-for="(link, linDex) in item.links" :key="linDex">
                                        <a :href="link.url" target="_blank">{{ link.title }}</a>
                                    </li>
                                </ul>
                            </div>
                        </template>

                        <template v-if="item.type === 'note'">
                            <div v-html="item.html" class="right w100 note"></div>
                        </template>

                        <template v-if="item.type === 'string' || !item.type">
                          <InputField :label="item.caption" v-model="newDataConfig[item.name]" ></InputField>
<!--                            <div class="right w100 form-group with-copy-icon mb-0 with_top_block">-->
<!--                                <span class="form_group_top_block">{{item.caption}}</span>-->
<!--                                <input type="text" class="control-input" v-model="newDataConfig[item.name]">-->
<!--                            </div>-->
                        </template>

                        <template  v-if="item.type === 'select'">
                            <div class="right w100">
                                <h3>{{item.caption}}</h3>
	                            <v-select v-model="newDataConfig[item.name]" :clearable="false" :searchable="false" :options="item.options" />
                            </div>
                        </template>

                        <template v-if="item.type === 'multi-select'">
                            <div class="right w100">
                                <h3>{{item.caption}}</h3>
	                            <multi-select :options="item.options" v-model="newDataConfig[item.name]" />
<!--                                <div class="right-check-inner" v-for="(option, optindex) in item.options" :key="optindex">-->
<!--                                    <label class="switch_checkbox_item" >-->
<!--                                        <input type="checkbox" v-model="newDataConfig[item.name][option]">-->
<!--                                        <div class="switch_checkbox"><span></span></div>-->
<!--                                    </label>-->
<!--                                    <h3>{{option}}</h3>-->
<!--                                </div>-->
                            </div>
                        </template>

                        <template v-if="item.type === 'boolean'">
                            <label class="switch_checkbox_item">
                                <input type="checkbox" v-model="newDataConfig[item.name]">
                                <div class="switch_checkbox"><span></span></div>
                              <h3>{{item.caption}}
                                <div class="info_btn" v-if="item.hint">
                                  <inline-svg :src="require('@/assets/img/info_icon.svg')"/>
                                  <div class="tooltip">{{item.hint}}</div>
                                </div>
                              </h3>
                            </label>
                        </template>

                    </div>
                </template>

                <p class="settings-hide-msg" v-else>
	                No settings...
<!--                    No settings for this app (at the account )...-->
<!--                    You can check account wide settings...-->
                </p>

            </div>

            <div class="bottom_btns_wrpr">
                <a @click="closePopup" class="btn brdr_btn">Cancel</a>
                <a @click="saveApps" class="btn">Save changes</a>
            </div>
        </div>
        <div class="popup_right_side">
            <Loading v-show="loadingHowTo"/>
            <template v-if="showRightPanel">
                <h3 class="popup_title" style="margin: 0 20px">How it works?</h3>
                <div v-if="howto !== false" v-html="howto" class="right-side-html"></div>
                <div v-else class="right-side-html">
                    <p>Coming soon!</p>
                </div>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import Loading from "@/components/Loading.vue"
import API from "@/api"
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
import DetailsPopup from "@/components/base/details-popup";
import detailsParts from "@/components/popup-details-parts/"
import MultiSelect from "@/views/apps/multi-select";
import VSwitch from "@/components/base/v-switch";

export default {
    name: "AppDetails",
	title: "App Details | Funnelish™",
    components: {VSwitch, MultiSelect, InputField, Loading, VButton, DetailsPopup, ...detailsParts },
    mixins: [API],
    data() {
        return {
            loadingHowTo: false,
            loading: true,
            showRightPanel: false,
            selectValue: '',
            selectOptions: ["United States", "Canada", "Ukraine", "Germany"],
            settingsToggle: true,
            app: {
                attributes: {},
            },
            thisApp: {
                attributes: {}
            },
            howto: {},
            config: [],
            newDataConfig: {},
        }
    },
    computed: {
        attributesData() {
            return this.app.attributes;
        },
        attributesSchema() {
            return this.thisApp.attributes;
        },
        isActive() {
            return this.attributesData.active;
        },
        isPanel() {
            return this.showRightPanel;
        },
        configData: {
            get() {
                return this.attributesData.config
            },
            set(val) {
                this.newDataConfig[val.name] = val.value;
            }
        },
        configSchema() {
            return this.attributesSchema.config;
        },
        id() {
            return this.app.id || this.$route.params.id;
        }
    },
    methods: {
        toggleActive() {
            this.app.attributes.active = !this.app.attributes.active;
        },
        togglePanel() {
            this.showRightPanel = !this.showRightPanel;
        },
        closePopup() {
            this.$router.push({path: '/apps'});
        },
        async saveApps() {
            this.loading = true;
            this.app.attributes.config = JSON.stringify(this.newDataConfig);

			var result = await this.patchUserApp(this.id, this.app);

            if (result.status === 200) {
                this.$emit('update', result.data.data);
                this.closePopup();
                this.$store.commit("closeSettingsPopup");
            } else {
                alert('Something went wrong... Please try again later');
            }
        },
        async init(id) {
            //this.$store.commit("showSettingsPopup");

            var appRes = await this.getUserApp(id);
            this.app = await appRes.data.data;

            var included = await appRes.data.included.find(item => parseInt(item.id) === id);

            this.thisApp = included;

            this.config = this.thisApp.attributes.config.length ? JSON.parse(this.thisApp.attributes.config) : [];

            this.newDataConfig = this.app.attributes.config ? JSON.parse(this.app.attributes.config) : {}

	        document.title = this.thisApp.attributes.name + " | Funnelish™";

            this.$nextTick(()=>this.loading = false);
        },
        async loadHowTo(id) {
            try {
                this.loadingHowTo = true;
                let res = await this.getAppHowto(id)
                this.howto = res.data ? await res.data.data.attributes.howto : false
            } catch (e) {
                // TODO:
            } finally {
                this.loadingHowTo = false;
            }
        }
    },
    created() {
        var id = parseInt(this.$route.params.id);

        this.init(id);
        this.loadHowTo(id);
    }
}
</script>
<style lang="scss" scoped>
.on-button {
	.active {
		color: $dark-grey;
	}
	.inactive {
		color: red;
	}
}
</style>
<style lang="scss">
.right-side-html {
    position: relative;
    overflow: auto;
    height: 100%;
    padding: 15px 15px;
}
.helpbox {
    background: #f6f9fe;
    border-radius: 8px;
    padding: 15px;
}
.form-group.mb-0 {
    margin-bottom: 0;
}
.right.w100 {
    width: 100%;
}

.info_btn {
    position: relative;
}
.info_btn .tooltip {
    position: absolute;
    width: 360px;
    background-color: #fff;
    padding: 5px;
    text-align: center;
    font-size: 12px;
    border: 1px solid #E4E6F1;
    border-radius: 3px;
    color: #636a7b;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
    bottom: calc(100% + 10px);
    right: 0;
    left: auto;
    transform: none;
}
.info_btn:hover .tooltip {
    opacity: 1;
    visibility: visible;
}
.app_settings_popup .popup_right_side .right-side-html p {
    margin-top: 0;
    margin-bottom: 15px;
}
.app_settings_popup .popup_right_side .right-side-html p + p {
    background: #EBEFF6!important;
    border-radius: 4px!important;
    border: none!important;
    padding: 3px 7px!important;
}
.right-side-html iframe {
    width: 100%;
    height: 200px;
    border: 5px solid #EBEFF6;
    border-radius: 12px;
    overflow: hidden;
}
.right-side-html img {
    display: block;
    max-width: 100%;
    height: auto;
}
.right-side-html a {
    color: #4368e0;
}
.right-side-html h5 {
    margin-top: 40px;
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.02em;
    color: #252A32;
}
.right-side-html ul li {
    padding-left: 18px;
    position: relative;
    margin-bottom: 15px;
}
.right-side-html ul li:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    left: 0px;
    top: 4px;
    background: #D5E5FF;
    border-radius: 100%;
}
.right-side-html ol {
   padding-left: 18px;
}
.right-side-html ol li {
    margin-bottom: 15px;
}
.right-check-inner {
    display: flex;
    margin-top: 15px;
}
.brdr_box_w_checkbox:empty {
    display: none;
}
/* .funnel-app-settings {
    overflow: visible
} */
</style>
